module.exports = __webpack_public_path__ + "img/gn_01.f6c3cd14.png";